module.exports = __webpack_public_path__ + "static/media/diktat-35.b1eca1b4.mp3";